import qs from "qs";

import { UrlProvider } from "../../api/UrlProvider";

export const AUTH_LOGIN_PAGE_TYPE = {
  PASSWORD: "password"
};

export const AUTH_LOGIN_PAGE_TYPE_QUERY_KEY = "type";

function parseSearchParams(search = "") {
  if (!search) {
    return {};
  }

  return qs.parse(search, { ignoreQueryPrefix: true });
}

function buildLoginHref(locale, params) {
  const base = UrlProvider.getUrl("fe.login", { locale });
  const query = qs.stringify(params, { encode: false, skipNulls: true });

  return query ? `${base}?${query}` : base;
}

export function getIsPasswordLoginPage(search = "") {
  const params = parseSearchParams(search);

  return params[AUTH_LOGIN_PAGE_TYPE_QUERY_KEY] === AUTH_LOGIN_PAGE_TYPE.PASSWORD;
}

export function getIsPasswordLoginFromRouteParams(routeParams = {}) {
  return (
    routeParams?.[AUTH_LOGIN_PAGE_TYPE_QUERY_KEY] ===
      AUTH_LOGIN_PAGE_TYPE.PASSWORD ||
    routeParams?.type === AUTH_LOGIN_PAGE_TYPE.PASSWORD
  );
}

export function resolveIsPasswordLogin({
  search = "",
  routeParams = {}
} = {}) {
  if (search) {
    return getIsPasswordLoginPage(search);
  }

  return getIsPasswordLoginFromRouteParams(routeParams);
}

/** Login URL with type=password, preserving other query params. */
export function getPasswordLoginHref(locale, search = "") {
  const params = parseSearchParams(search);
  params[AUTH_LOGIN_PAGE_TYPE_QUERY_KEY] = AUTH_LOGIN_PAGE_TYPE.PASSWORD;

  return buildLoginHref(locale, params);
}

/** Default OTP login URL, stripping type=password, preserving other query params. */
export function getOtpLoginHref(locale, search = "") {
  const params = parseSearchParams(search);
  delete params[AUTH_LOGIN_PAGE_TYPE_QUERY_KEY];

  return buildLoginHref(locale, params);
}
